import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { Card, CardContent, Divider, List, ListItem, ListItemIcon, ListItemText, Chip, Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";

import DescriptionIcon from "@material-ui/icons/Description";
import YouTubeIcon from "@material-ui/icons/YouTube";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import * as Admin from "../../../store/ducks/admin.duck";

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },

  panel: {
    borderRadius: 12,
    height: "100%",
  },

  panelContent: {
    padding: theme.spacing(2),
  },
}));

export default function Policies() {
  const classes = useStyles();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(Admin.actions.fetchPolicyItems());
  }, [dispatch]);
  const policyItems = useSelector((state) => state.admin.PolicyItems);
  const centralisedPolicies = policyItems.filter((x) => x.type === "CentralisedService");
  const generalPolicies = policyItems.filter((x) => x.type === "General");

  const renderPolicyPanel = (title, items) => (
    <Card className={classes.panel}>
      <CardContent className={classes.panelContent}>
        <Typography variant="h5" gutterBottom>
          {title}
        </Typography>

        <Divider />

        <List dense>
          {items.map((item) => {
            const isPdf = item.pdf_url !== "";

            const url = isPdf ? `https://files.ruralhealthconnect.com.au/fileStoreRHC/${item.pdf_url}` : item.youtube_url;

            return (
              <React.Fragment key={item.title}>
                <ListItem button component="a" href={url} target="_blank" rel="noopener noreferrer">
                  <ListItemIcon>{isPdf ? <DescriptionIcon color="primary" /> : <YouTubeIcon color="secondary" />}</ListItemIcon>

                  <ListItemText primary={item.title} />

                  <Chip size="small" label={isPdf ? "PDF" : "Video"} />

                  <OpenInNewIcon color="action" style={{ marginLeft: 12 }} />
                </ListItem>

                <Divider />
              </React.Fragment>
            );
          })}
        </List>
      </CardContent>
    </Card>
  );

  return (
    <div className={classes.root}>
      <Typography variant="h4" gutterBottom>
        Policies
      </Typography>

      <Typography color="textSecondary" paragraph>
        Browse our collection of policies.
      </Typography>

      <Grid container spacing={3}>
        {centralisedPolicies.length > 0 && (
          <Grid item xs={12} md={6}>
            {renderPolicyPanel("Centralised Service", centralisedPolicies)}
          </Grid>
        )}

        {generalPolicies.length > 0 && (
          <Grid item xs={12} md={6}>
            {renderPolicyPanel("General", generalPolicies)}
          </Grid>
        )}
      </Grid>
    </div>
  );
}
